var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "新增核销订单",
        visible: _vm.visible,
        width: "900px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.formData, "label-width": "100px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "核销码：" } },
            [
              _c(
                "el-input",
                {
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: "请输入核销码" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSearch($event)
                    },
                  },
                  model: {
                    value: _vm.formData.pickupCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "pickupCode", $$v)
                    },
                    expression: "formData.pickupCode",
                  },
                },
                [
                  _c("el-button", {
                    attrs: {
                      slot: "append",
                      icon: "el-icon-search",
                      loading: _vm.searchLoading,
                    },
                    on: { click: _vm.handleSearch },
                    slot: "append",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.orderInfo
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: [_vm.orderInfo], border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单编号",
                  "min-width": "200",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.orderNo
                            ? _c("div", [
                                _c("div", [_vm._v(_vm._s(scope.row.orderNo))]),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  678161767
                ),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名称",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "productType", label: "商品分类", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "payTime", label: "支付时间", width: "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.payTime
                            ? _c("div", [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(scope.row.payTime.split(" ")[0])
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(scope.row.payTime.split(" ")[1])
                                  ),
                                ]),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2309118970
                ),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "validityPeriod",
                  label: "项目有效期",
                  width: "180",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.validityPeriod
                            ? _c("div", [
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.validityPeriod)),
                                ]),
                              ])
                            : _c("span", [_vm._v("永久")]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3079366967
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: !_vm.orderInfo,
                loading: _vm.confirmLoading,
              },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确认核销")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }